import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styles from "./PaymentVerify.module.css";
import { apiUrl } from "./Constants/Constants";
import { toast } from "react-toastify";
import axios from "axios";
import CtaBtns from "./Components/CtaBtns/CtaBtns.module";
const PaymentVerify = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // اطلاعات وضعیت پرداخت از سرور یا مسیر URL
  const [searchParams, setSearchParams] = useSearchParams();
  const [stater, setStater] = useState(searchParams.get("Status"));
  const [authority, setAuthority] = useState(searchParams.get("Authority"));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const paymentStatus = stater == "OK" ? "OK" : "failed";

  useEffect(() => {
    senders();
  }, []);
  const senders = async () => {
    if (paymentStatus === "OK" && authority != null) {
      setLoading(true);
      try {
        // ارسال درخواست به سرور
        const response = await axios.post(apiUrl + "user/verify-payment/", {
          authority,
        });

        if (response.status === 200) {
          toast.success("تغیرات با موفقیت اعمال گردید");
          setTimeout(() => {
            navigate("/");
          }, 200);
          //   console.log("OTP sent successfully:", response.data);
        } else {
          // setError("خطا در ارسال کد تأیید.");
        }
      } catch (err) {
        setError("خطایی رخ داده است. لطفاً دوباره تلاش کنید.");
      } finally {
        setLoading(false);
      }
    }
  };
  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <div className={styles.container}>
      <div
        className={`${styles.resultCard} ${
          paymentStatus == "OK" ? styles.success : styles.failed
        }`}
      >
        <div className={styles.icon}>
          {paymentStatus == "OK" ? (
            <i className="fas fa-check-circle"></i>
          ) : (
            <i className="fas fa-times-circle"></i>
          )}
        </div>
        <div className={styles.message}>
          {paymentStatus == "OK" ? (
            <>
              <div className={styles.notifies}>
                پرداخت شما با موفقیت انجام شد.
              </div>
              <div className={styles.notifyonserver}>
                در حال اعمال تغییرات
                <br />
                از بستن این صفحه جدا خودداری نمایید.
              </div>
            </>
          ) : (
            <>
              <div className={styles.notifies}>پرداخت ناموفق بود!</div>
              <div className={styles.notifyonserver}>
                <br />
                در صورت کسر وجه از حساب شما نهایتا تا ۷۲ ساعت آینده به حساب شما
                عودت داده خواهد شد.
              </div>
            </>
          )}
        </div>
        <div className={styles.details}>
          <p>{/* <strong>مبلغ:</strong> {paymentAmount} تومان */}</p>
          <p>{/* <strong>شماره پیگیری:</strong> {trackingId} */}</p>
        </div>
        {!loading && (
          <CtaBtns className={styles.backButton} onAtion={handleBackToHome}>
            بازگشت به صفحه اصلی
          </CtaBtns>
        )}
      </div>
    </div>
  );
};

export default PaymentVerify;
